"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
const _ = __importStar(require("lodash"));
const util_math_1 = require("./util_math");
class TTouch {
    // eslint-disable-next-line no-useless-constructor
    constructor(identifier, point, button = undefined, targetings = []) {
        this.identifier = identifier;
        this.point = point;
        this.button = button;
        this.targetings = targetings;
    }
}
exports.TTouch = TTouch;
class TTouchEvent {
    // eslint-disable-next-line no-useless-constructor
    constructor(touches, t = util_1.now(), platform = null) {
        this.touches = touches;
        this.t = t;
        this.platform = platform;
    }
    get shiftKey() { return util_math_1.safeKey(this.platform, 'shiftKey'); }
    get altKey() { return util_math_1.safeKey(this.platform, 'altKey'); }
    get metaKey() { return util_math_1.safeKey(this.platform, 'metaKey'); }
    get ctrlKey() { return util_math_1.safeKey(this.platform, 'ctrlKey'); }
    // Convenient function
    get targetings() {
        return _.uniq(_.flatMap(this.touches, touch => touch.targetings));
    }
}
exports.TTouchEvent = TTouchEvent;
// ---- Overridable interfaces (View/platform code should override).
//      Platform independent override that prevents the platform dependent
//      behavior associated with a gesture.
//
TTouchEvent.commit = (_) => {
    console.log("++++ TTouchEvent commit");
};
